
seedWebApp.controller('AddProductModalController', ['$scope', '$uibModalInstance', '$routeParams', 'TranslationService', 'order', 'pointID',
    function AddProductModalController($scope, $uibModalInstance, $routeParams, TranslationService, order, pointID) {
        $scope.translation = TranslationService.getActiveTranslation();
        $scope.order = order;
        $scope.pointID = pointID;
        console.log('AddProductModalCtrl.order ' + pointID);
        console.log(order);


        $routeParams.route = pointID;

        $scope.ContactID = order.ContactID;
        $scope.hideBackButton = true;
        $scope.hideCartButton = true;

        $scope.dash = {
            selectedSkuID: null,
            selProduct: null,
            items: [],
            quotes: [],
            adders: [],
            logistics: [],
            favorites: [],
            currencySymbol: 'US$',
        };

        $scope.product = {
            SkuID: ''
        };

        $scope.addCart = function (contactID, product) {
            console.log('addCart');
            //$scope.product = product;
            $uibModalInstance.close(product);
        };

        $scope.ok = function () {
            $uibModalInstance.close($scope.product);
        };


        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);